export default __webpack_public_path__ + "static/media/Settings.a85a34ba.svg";